import React, { useState, } from 'react'
import { getPartner, getPartnerGuid } from '../../../../../lib/access.es6';
import AlertDialog from '../../../../../components/AlertDialog/index.es6';
import { CircularProgress } from '@material-ui/core';
import { Button } from '@mui/material';
import { find } from 'lodash';
import NavButtons from './NavButtons';
import ViewMembers from './ViewMembers';
import Adddependant from './AddDependant';
import { COMPONENT_TYPES } from '../../helpers';
import SelectPremium from './SelectPlan/SelectPremium';
import PersonsCovered from './PersonsCovered';


const CreateQuote = (props) => {

  const [currentComponent, setCurrentComponent] = useState(COMPONENT_TYPES.SELECT_PLAN);
  const [selectedPlan, setPlan] = useState(null);
  const [selectedPremium, setSelectedPremium] = useState(null);
  const [parentsPlan, setParentsPlan] = useState(null);
  const [members, setMembers] = useState([]);



  const [togglequoteanddependant, settogglequoteanddependant] = useState(true)
  const [dependants, setDependants] = useState([])
  const [depAlert, setDepAlert] = useState(false);


  const [monthlyPremium, setMonthlyPremium] = useState()
  const [chpPremium, setChpPremiums] = useState(0)


  // useEffect(() => {


  //   if (props.productDetails.code === "chp_care_benefit") {
  //     setCurrentComponent(COMPONENT_TYPES.ADD_DEPENDANT)
  //   }
  // }, [props.plans]);

  const handleAdddependant = () => {
    settogglequoteanddependant(!togglequoteanddependant)
  }


  const removeDependant = (uuid) => {
    const item = find(dependants, { uuid: uuid })
    if (item.relationship === 'Principal') {
      setDependants([])
    } else {
      const updatedDependants = dependants.filter(item => item.uuid !== uuid);
      setDependants(updatedDependants);

    }
  };

  const getGranularity = () => {
    if(selectedPremium.frequency === "Annual") return "year"
    if(selectedPremium.frequency === "Monthly") return "month"
    if(selectedPremium.frequency === "Quarterly") return "month"
    if(selectedPremium.frequency === "Semi-Annual") return "month"
  }

  const getCardinality = () => {
    if(selectedPremium.frequency === "Annual") return 1
    if(selectedPremium.frequency === "Semi-Annual") return 6
    if(selectedPremium.frequency === "Quarterly") return 3
    if(selectedPremium.frequency === "Monthly") return 1
  }

  const handleCreateQuote = () => {
    // attachBenefits()
    const payload = {
      "product_guid": props.productDetails.guid,
      "product_name": props.productType,
      "product_code": props.productDetails.code,
      "customer_guid": props.principal.guid,
      "partner": getPartnerGuid(),
      "lapse_period": 12,
      "lapse_period_granularity": getGranularity(),
      "lapse_period_cardinality": getCardinality(),
      "premium_granularity": getGranularity(),
      "premium_cardinality": getCardinality(),
      "policy_schedule_entries": [
        ...members.map((member) => {
            return {
              ...member,
              premium_amount_in_cents: member.relationship === 'Principal' ? selectedPremium.CHP * 100 :( member.relationship === 'Spouse' ? selectedPremium.SPOUSE : selectedPremium.CHILD) * 100,
              benefits: [
                {
                  type: "HOSPITAL ADMISSION",
                  cover_amount_in_cents: 30000 * 100,
                  waiting_period_in_days: 30,
                  cover_usage_count: 30,
                  benefit_period_cardinality: 1,
                  benefit_period_granuality: "year",
                  premium_amount: 0,
                  is_initialized: true,
                  additional_details: {
                    premium_amount: 0,
                  }
          
                },
                {
                  type: "CANCER CARE",
                  cover_amount_in_cents: 20000000,
                  waiting_period_in_days: 30,
                  cover_usage_count: 0,
                  benefit_period_cardinality: 1,
                  benefit_period_granuality: "year",
                  premium_amount: 0,
                  is_initialized: true,
                  additional_details: {
                    premium_amount: 0,
                  }
          
                },
                {
                  type: "LAST EXPENSE",
                  cover_amount_in_cents: 5000000,
                  waiting_period_in_days: 30,
                  cover_usage_count: 0,
                  benefit_period_cardinality: 1,
                  benefit_period_granuality: "year",
                  premium_amount: 0,
                  is_initialized: true,
                  additional_details: {
                    premium_amount: 0,
                  }
          
                },
              ]
          }
        })
      ],
      additional_details: {
        "monthly_premium": monthlyPremium,
        "plan_name": ""
      }
    }
    console.log("quotepayload", payload)
    props.createQuote(payload)


  }

  const handleQuoteCreatedSuccessfully = () => {
    props.resetAddQuoteSuccessAlert();

  }

  const handleQuoteCreateError = () => {
    props.resetAddQuoteErrorAlert();

  }

  const handlenextStep = () => {
    props.handleNext();
  }





  const currencyCode = getPartner().country.currency_code

  return (
    <>

      {currentComponent === COMPONENT_TYPES.SELECT_PLAN &&
        <SelectPremium
          plans={props.plans}
          selectedPlan={selectedPlan}
          setPlan={setPlan}
          setCurrentComponent={() => {
            setCurrentComponent(COMPONENT_TYPES.SELECT_PAYMENT_PLAN)
          }}

          setSelectedPremium={(selectedPremium)=> {
            setSelectedPremium(selectedPremium)

          }}
          premiums = {props.plans}
        />
      }
      {

        currentComponent === COMPONENT_TYPES.ADD_DEPENDANT &&
        <Adddependant
          productCode={props.productCode}
          productType={props.productType}
          productDetails={props.productDetails}
          dependant={props.dependant}
          handleCreateQuote={handleCreateQuote}
          handleAdddependant={handleAdddependant}
          createQuote={props.createQuote}
          setDependants={setDependants}
          dependants={dependants}
          createDependant={props.createDependant}
          viewMembers={() => setCurrentComponent(COMPONENT_TYPES.VIEW_MEMBERS)}

          currencyCode={currencyCode}
          removeDependant={removeDependant}
          depAlert={depAlert}
          setDepAlert={setDepAlert}
          principal={props.principal}
          autoFillPrincipal={props.autoFillPrincipal}
          toggleAutoFillPrincipal={props.toggleAutoFillPrincipal}
          selectedPlan={selectedPlan}
          parentsPlan={parentsPlan}
    

          monthlyPremium={monthlyPremium}
          setMonthlyPremium={setMonthlyPremium}
          chpPremium={chpPremium}
          setChpPremiums={setChpPremiums}
        // suspendDuplicateIdCheck={suspendDuplicateIdCheck}

        />
      }

{
        currentComponent === COMPONENT_TYPES.VIEW_MEMBERS &&
        <PersonsCovered
          mainMember = {dependants[0]}
          selectedPremium = {selectedPremium}
          handleCreateQuote={handleCreateQuote}
          members={members}
          setMembers={setMembers}
          goBack={() => {
            setCurrentComponent(COMPONENT_TYPES.SELECT_PLAN)
          }}
        />
}


      {
        currentComponent === COMPONENT_TYPES.VIEW_MEMBERsS &&
        <ViewMembers
          productCode={props.productCode}
          currencyCode={currencyCode}
          removeDependant={removeDependant}
          dependants={dependants}
          addAnotherMember={() => {
            //setMemberRelationshipType(relationshipType)
            setCurrentComponent(COMPONENT_TYPES.ADD_DEPENDANT)
            //setCurrentRelationShip(null)
          }}
          //setOpenAddBenefitsDialog={setOpenAddBenefitsDialog}
          //additionalBenefits={additionalBenefits}
          selectedPlan={selectedPlan}
          parentsPlan={parentsPlan}
          handleCreateQuote={handleCreateQuote}

          monthlyPremium={monthlyPremium}
          chpPremium={chpPremium}
        />
      }



      <NavButtons
        currentComponent={currentComponent}
        setCurrentComponent={setCurrentComponent}
        selectedPlan={selectedPlan}
        setPlan={setPlan}
        parentsPlan={parentsPlan}
        setParentsPlan={setParentsPlan}
      />


      <AlertDialog
        custom
        show={props.showAddQuoteProgressAlert}
        size="sm"
        style={{ marginTop: '0', top: '30vh' }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        showTitle={false}
        confirmBtnCssClass
      >
        <CircularProgress />
        <h2> Creating Quote...</h2>
      </AlertDialog>

      <AlertDialog
        success
        show={props.showAddQuoteSuccessAlert}
        size="sm"
        title={'Quote  created'}
        style={{ marginTop: '0', top: '30vh' }}
        onConfirm={() => { handleQuoteCreatedSuccessfully() }}
        confirmBtnText={'ok'}
        showCancel={false}
        showConfirm={false}
        cancelBtnText={'cancel'}
        confirmBtnCssClass
      >
        <div >
          <Button variant="contained" onClick={() => { handlenextStep() }} style={{ background: 'green', }}>View Quote Details</Button>
        </div>
      </AlertDialog>

      <AlertDialog
        show={props.showAddQuoteErrorAlert}
        danger
        title={'Error creating Quote'}
        onConfirm={() => handleQuoteCreateError()}
        confirmBtnText={'Try again'}
        confirmBtnCssClass
        showCancel={false}
        style={{ marginTop: '0', top: '30vh' }}
      >
        {
          props.createQuoteError ? props.createQuoteError.message : ""
        }
      </AlertDialog>

      <hr />

      {/* {selectedPlan &&
        <>
          {dependants.length > 0 &&
            <div className={classes.createquote}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={handleCreateQuote}
              >
                Create Quote
              </Button>
            </div>
          }
        </>
      } */}

    </>
  )
}

export default CreateQuote


